import LabelledSwitch from '../LabelledSwitch';
import LangConfirmationField from '../LangConfirmationField';
import WarningIcon from '@material-ui/icons/Warning';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import GS from '../../grafsync/grafsync';
import BasicReadField from '../BasicReadField';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';
import CommonIriDisplay from '../../application-core/CommonIriDisplay';
import withGS from '../withGShoc';
import BasicLangChip from '../BasicLangChip';
import { computeLabelFromType, getProjectFromGraph } from '../utils/utils';
import { Typography } from '@material-ui/core';
import { MAX_DESCRIPTION_LENGTH } from '../utils/constants';

class QueryParameterDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            areYouSure: false
        };
    }

    onUpdate = (property) => (value) => {
        const lang = this.props.defaultLang;
        this.props.onUpdate(property, value, lang, 0);
    };

    onUpdateOptional = (checked) => {
        this.props.data.optional !== undefined ? this.props.onUpdate('optional', checked) : this.props.onAdd('optional', true);
    };

    render() {

        const { data, queryVars, classes, isReadOnly, onDelete, id, defaultLang, graph } = this.props;
        const description = data.description;
        const alias = GS.getAlias(data.queryReplacementType);
        const label = data.queryReplacementType.startsWith("http://www.w3.org/2001/XMLSchema#") ?
            "XSD " + data.queryReplacementType.substring(33)
            :
            computeLabelFromType(alias);;
        const valid = queryVars.includes("?" + data.queryVariable);

        return (
            <div
                data-test={"parameter-detail-" + data.queryVariable}
                className={!valid ? classes.incompleteData : null}
                style={{
                    padding: '6px 6px 0px 6px',
                    borderRadius: 4,
                    border: 'solid 1px #c0c0c0',
                    marginBottom: 12
                }}>
                {!isReadOnly &&
                    <Tooltip title='Delete parameter'>
                        <span style={{ float: 'right', marginBottom: 6 }}>
                            <Typography variant="body2">
                                <IconButton data-test="delete-parameter" size="small" onClick={() => onDelete(id)} className={classes.deleteButton}>
                                    <DeleteIcon />
                                </IconButton>
                            </Typography>
                        </span>
                    </Tooltip>
                }
                {!valid && <Typography variant="body2" style={{ marginBottom: 6 }}>
                    <WarningIcon data-test="warning" style={{ verticalAlign: 'bottom' }} />
                    <span style={{ marginLeft: 8 }}>Name changed in editor.</span>
                </Typography>}
                <Typography variant='caption' style={{ color: 'black', marginTop: 12, margiBottom: 6 }}>Variable Name</Typography>
                <div>
                    <BasicReadField
                        disabled={!valid}
                        dataTest="parameter-name"
                        fullWidth
                        text={data.queryVariable} />
                </div>
                <Typography variant='caption' style={{ color: 'black', marginTop: 12, marginBottom: 6 }}>Instructions for User</Typography>
                <LangConfirmationField
                    dataTest="parameter-description"
                    onUpdate={this.onUpdate("description")}
                    focus={false}
                    canBeDeleted={false}
                    maxLength={MAX_DESCRIPTION_LENGTH}
                    multiline={true}
                    allowEmpty={false}
                    text={description && description[defaultLang] ? description[defaultLang] : ""}
                    lang={defaultLang}
                    isReadOnly={isReadOnly} />
                <LabelledSwitch
                    isReadOnly={isReadOnly}
                    disabled={isReadOnly}
                    dataTest="optional"
                    checked={data.optional}
                    handleChange={this.onUpdateOptional}
                    label="Optional" />
                <Typography variant='caption' style={{ color: 'black', marginTop: 12, marginBottom: 6 }}>Expected Type</Typography>
                <div data-test="expected-type" style={{ marginTop: 6 }}>
                    <BasicLangChip
                        id={data.queryReplacementType}
                        viewLang="en"
                        isReadOnly={true}
                        defaultLang="en"
                        label={{
                            "en": label
                        }} />
                </div>
                {"queryConstraint" in data &&
                    <div>
                        <Typography variant='caption' style={{ color: 'black', marginTop: 12, marginBottom: 6 }}>Select From</Typography>
                        <div data-test="select-from" style={{ marginTop: 6 }}>
                            <CommonIriDisplay
                                id={data.queryConstraint}
                                compact={true}
                                projectIRI={getProjectFromGraph(graph)}
                                handleNotAvailable={true}
                                loadComponents={false}
                                graph={graph}
                                wrap={false}
                                viewLang={this.props.defaultLang}
                                defaultLang={this.props.defaultLang} />
                        </div>
                    </div>
                }
            </div>
        );
    }
}

QueryParameterDetail.defaultProps = {
    isReadOnly: true,
    reportOption: false
};

QueryParameterDetail.propTypes = {
    data: PropTypes.object.isRequired,
    graph: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    isReadOnly: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired,
    queryVars: PropTypes.array,
    classes: PropTypes.object
};

export default withStyles(styles)(withGS(QueryParameterDetail));